* {
  --bosch-red-95: #ffecec;
  --bosch-red-90: #ffd9d9;
  --bosch-red-85: #ffc6c6;
  --bosch-red-80: #ffb2b2;
  --bosch-red-75: #ff9d9d;
  --bosch-red-70: #ff8787;
  --bosch-red-65: #ff6e6f;
  --bosch-red-60: #ff5152;
  --bosch-red-55: #ff2124;
  --bosch-red-50: #ed0007;
  --bosch-red-45: #d50005;
  --bosch-red-40: #be0004;
  --bosch-red-35: #a80003;
  --bosch-red-30: #920002;
  --bosch-red-25: #7d0002;
  --bosch-red-20: #680001;
  --bosch-red-15: #540001;
  --bosch-red-10: #410000;
  --bosch-red-5: #2d0000;
  --bosch-purple-95: #f7eef6;
  --bosch-purple-90: #f0dcee;
  --bosch-purple-85: #ebcae8;
  --bosch-purple-80: #e8b6e3;
  --bosch-purple-75: #e5a2df;
  --bosch-purple-70: #e48cdd;
  --bosch-purple-65: #e472db;
  --bosch-purple-60: #e552da;
  --bosch-purple-55: #d543cb;
  --bosch-purple-50: #c535bc;
  --bosch-purple-45: #b12ea9;
  --bosch-purple-40: #9e2896;
  --bosch-purple-35: #8b2284;
  --bosch-purple-30: #791d73;
  --bosch-purple-25: #671761;
  --bosch-purple-20: #551151;
  --bosch-purple-15: #440c41;
  --bosch-purple-10: #340731;
  --bosch-purple-5: #230421;
  --bosch-blue-95: #e8f1ff;
  --bosch-blue-90: #d1e4ff;
  --bosch-blue-85: #b8d6ff;
  --bosch-blue-80: #9dc9ff;
  --bosch-blue-75: #7ebdff;
  --bosch-blue-70: #56b0ff;
  --bosch-blue-65: #00a4fd;
  --bosch-blue-60: #0096e8;
  --bosch-blue-55: #0088d4;
  --bosch-blue-50: #007bc0;
  --bosch-blue-45: #006ead;
  --bosch-blue-40: #00629a;
  --bosch-blue-35: #005587;
  --bosch-blue-30: #004975;
  --bosch-blue-25: #003e64;
  --bosch-blue-20: #003253;
  --bosch-blue-15: #002742;
  --bosch-blue-10: #001d33;
  --bosch-blue-5: #001222;
  --bosch-turquoise-95: #def5f3;
  --bosch-turquoise-90: #b6ede8;
  --bosch-turquoise-85: #a1dfdb;
  --bosch-turquoise-80: #8dd2cd;
  --bosch-turquoise-75: #79c5c0;
  --bosch-turquoise-70: #66b8b2;
  --bosch-turquoise-65: #54aba5;
  --bosch-turquoise-60: #419e98;
  --bosch-turquoise-55: #2e908b;
  --bosch-turquoise-50: #18837e;
  --bosch-turquoise-45: #147671;
  --bosch-turquoise-40: #116864;
  --bosch-turquoise-35: #0e5b57;
  --bosch-turquoise-30: #0a4f4b;
  --bosch-turquoise-25: #07423f;
  --bosch-turquoise-20: #053634;
  --bosch-turquoise-15: #032b28;
  --bosch-turquoise-10: #02201e;
  --bosch-turquoise-5: #011413;
  --bosch-green-95: #e2f5e7;
  --bosch-green-90: #b8efc9;
  --bosch-green-85: #9be4b3;
  --bosch-green-80: #86d7a2;
  --bosch-green-75: #72ca92;
  --bosch-green-70: #5ebd82;
  --bosch-green-65: #4ab073;
  --bosch-green-60: #37a264;
  --bosch-green-55: #219557;
  --bosch-green-50: #00884a;
  --bosch-green-45: #007a42;
  --bosch-green-40: #006c3a;
  --bosch-green-35: #005f32;
  --bosch-green-30: #00512a;
  --bosch-green-25: #004523;
  --bosch-green-20: #00381b;
  --bosch-green-15: #002c14;
  --bosch-green-10: #00210e;
  --bosch-green-5: #001507;
  --bosch-gray-95: #eff1f2;
  --bosch-gray-90: #e0e2e5;
  --bosch-gray-85: #d0d4d8;
  --bosch-gray-80: #c1c7cc;
  --bosch-gray-75: #b2b9c0;
  --bosch-gray-70: #a4abb3;
  --bosch-gray-65: #979ea4;
  --bosch-gray-60: #8a9097;
  --bosch-gray-55: #7d8389;
  --bosch-gray-50: #71767c;
  --bosch-gray-45: #656a6f;
  --bosch-gray-40: #595e62;
  --bosch-gray-35: #4e5256;
  --bosch-gray-30: #43464a;
  --bosch-gray-25: #383b3e;
  --bosch-gray-20: #2e3033;
  --bosch-gray-15: #232628;
  --bosch-gray-10: #1a1c1d;
  --bosch-gray-5: #101112;
  --bosch-yellow-95: #ffefd1;
  --bosch-yellow-90: #ffdf95;
  --bosch-yellow-85: #ffcf00;
  --bosch-yellow-80: #eec100;
  --bosch-yellow-75: #deb300;
  --bosch-yellow-70: #cda600;
  --bosch-yellow-65: #bd9900;
  --bosch-yellow-60: #ad8c00;
  --bosch-yellow-55: #9e7f00;
  --bosch-yellow-50: #8f7300;
  --bosch-yellow-45: #806700;
  --bosch-yellow-40: #725b00;
  --bosch-yellow-35: #644f00;
  --bosch-yellow-30: #564400;
  --bosch-yellow-25: #493900;
  --bosch-yellow-20: #3c2e00;
  --bosch-yellow-15: #2f2400;
  --bosch-yellow-10: #231a00;
  --bosch-yellow-5: #171000;
  --bosch-white: #ffffff;
  --bosch-black: #000000;
}

:root {
  --shadow-fill: rgba(0, 0, 0, 0.25);
}

:root, .-primary {
  --background: var(--bosch-white);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-90);
  --plain__enabled__fill__pressed: var(--bosch-gray-80);
  --plain__enabled__front__default: var(--bosch-black);
  --plain__enabled__front__hovered: var(--bosch-black);
  --plain__enabled__front__pressed: var(--bosch-black);
  --plain__focused__fill__default: var(--bosch-blue-95);
  --plain__focused__front__default: var(--bosch-black);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-80);
  --neutral__enabled__fill__default: var(--bosch-gray-90);
  --neutral__enabled__fill__hovered: var(--bosch-gray-80);
  --neutral__enabled__fill__pressed: var(--bosch-gray-70);
  --neutral__enabled__front__default: var(--bosch-black);
  --neutral__enabled__front__hovered: var(--bosch-black);
  --neutral__enabled__front__pressed: var(--bosch-black);
  --neutral__focused__fill__default: var(--bosch-blue-90);
  --neutral__focused__front__default: var(--bosch-black);
  --neutral__disabled__fill__default: var(--bosch-gray-90);
  --neutral__disabled__front__default: var(--bosch-gray-70);
  --small__enabled__fill__default: var(--bosch-gray-60);
  --small__enabled__fill__hovered: var(--bosch-gray-50);
  --small__enabled__fill__pressed: var(--bosch-gray-40);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-90);
  --small__disabled__front__default: var(--bosch-gray-70);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-black);
  --integrated__enabled__front__hovered: var(--bosch-blue-50);
  --integrated__enabled__front__pressed: var(--bosch-blue-40);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-80);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-90);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-80);
  --minor-accent__enabled__front__default: var(--bosch-blue-50);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-40);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-30);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-80);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-40);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-30);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-80);
  --major-accent__disabled__front__default: var(--bosch-gray-60);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-90);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-80);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --minor-signal-neutral__enabled__front__default: var(--bosch-black);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-black);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-black);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-90);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-80);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --minor-signal-error__enabled__front__default: var(--bosch-black);
  --minor-signal-error__enabled__front__hovered: var(--bosch-black);
  --minor-signal-error__enabled__front__pressed: var(--bosch-black);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-90);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-80);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-70);
  --minor-signal-warning__enabled__front__default: var(--bosch-black);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-black);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-black);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-90);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-80);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --minor-signal-success__enabled__front__default: var(--bosch-black);
  --minor-signal-success__enabled__front__hovered: var(--bosch-black);
  --minor-signal-success__enabled__front__pressed: var(--bosch-black);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-30);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-30);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-75);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-yellow-65);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-30);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-90);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-80);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-20);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-90);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-80);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-50);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-40);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-30);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-90);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-80);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-50);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-40);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-30);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-90);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-80);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-50);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-40);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-30);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-20);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-40);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-30);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-40);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-30);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-40);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-30);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}

.-secondary {
  --background: var(--bosch-gray-95);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-85);
  --plain__enabled__fill__pressed: var(--bosch-gray-75);
  --plain__enabled__front__default: var(--bosch-black);
  --plain__enabled__front__hovered: var(--bosch-black);
  --plain__enabled__front__pressed: var(--bosch-black);
  --plain__focused__fill__default: var(--bosch-blue-90);
  --plain__focused__front__default: var(--bosch-black);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-75);
  --neutral__enabled__fill__default: var(--bosch-gray-85);
  --neutral__enabled__fill__hovered: var(--bosch-gray-75);
  --neutral__enabled__fill__pressed: var(--bosch-gray-65);
  --neutral__enabled__front__default: var(--bosch-black);
  --neutral__enabled__front__hovered: var(--bosch-black);
  --neutral__enabled__front__pressed: var(--bosch-black);
  --neutral__focused__fill__default: var(--bosch-blue-85);
  --neutral__focused__front__default: var(--bosch-black);
  --neutral__disabled__fill__default: var(--bosch-gray-85);
  --neutral__disabled__front__default: var(--bosch-gray-65);
  --small__enabled__fill__default: var(--bosch-gray-55);
  --small__enabled__fill__hovered: var(--bosch-gray-45);
  --small__enabled__fill__pressed: var(--bosch-gray-35);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-85);
  --small__disabled__front__default: var(--bosch-gray-65);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-black);
  --integrated__enabled__front__hovered: var(--bosch-blue-45);
  --integrated__enabled__front__pressed: var(--bosch-blue-35);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-75);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-85);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-75);
  --minor-accent__enabled__front__default: var(--bosch-blue-45);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-35);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-25);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-75);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-40);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-30);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-75);
  --major-accent__disabled__front__default: var(--bosch-gray-55);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-85);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-75);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-65);
  --minor-signal-neutral__enabled__front__default: var(--bosch-black);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-black);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-black);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-85);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-75);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-65);
  --minor-signal-error__enabled__front__default: var(--bosch-black);
  --minor-signal-error__enabled__front__hovered: var(--bosch-black);
  --minor-signal-error__enabled__front__pressed: var(--bosch-black);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-75);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-65);
  --minor-signal-warning__enabled__front__default: var(--bosch-black);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-black);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-black);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-85);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-75);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-65);
  --minor-signal-success__enabled__front__default: var(--bosch-black);
  --minor-signal-success__enabled__front__hovered: var(--bosch-black);
  --minor-signal-success__enabled__front__pressed: var(--bosch-black);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-30);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-30);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-75);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-yellow-65);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-30);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-85);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-75);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-20);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-85);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-75);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-45);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-35);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-25);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-85);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-75);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-45);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-35);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-25);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-85);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-75);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-45);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-35);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-25);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-20);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-40);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-30);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-40);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-30);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-40);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-30);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}

.-contrast {
  --background: var(--bosch-gray-20);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-30);
  --plain__enabled__fill__pressed: var(--bosch-gray-40);
  --plain__enabled__front__default: var(--bosch-white);
  --plain__enabled__front__hovered: var(--bosch-white);
  --plain__enabled__front__pressed: var(--bosch-white);
  --plain__focused__fill__default: var(--bosch-blue-25);
  --plain__focused__front__default: var(--bosch-white);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-40);
  --neutral__enabled__fill__default: var(--bosch-gray-30);
  --neutral__enabled__fill__hovered: var(--bosch-gray-40);
  --neutral__enabled__fill__pressed: var(--bosch-gray-50);
  --neutral__enabled__front__default: var(--bosch-white);
  --neutral__enabled__front__hovered: var(--bosch-white);
  --neutral__enabled__front__pressed: var(--bosch-white);
  --neutral__focused__fill__default: var(--bosch-blue-30);
  --neutral__focused__front__default: var(--bosch-white);
  --neutral__disabled__fill__default: var(--bosch-gray-30);
  --neutral__disabled__front__default: var(--bosch-gray-50);
  --small__enabled__fill__default: var(--bosch-gray-60);
  --small__enabled__fill__hovered: var(--bosch-gray-70);
  --small__enabled__fill__pressed: var(--bosch-gray-80);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-30);
  --small__disabled__front__default: var(--bosch-gray-50);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-white);
  --integrated__enabled__front__hovered: var(--bosch-blue-70);
  --integrated__enabled__front__pressed: var(--bosch-blue-80);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-40);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-30);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-40);
  --minor-accent__enabled__front__default: var(--bosch-blue-70);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-80);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-90);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-40);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-60);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-70);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-40);
  --major-accent__disabled__front__default: var(--bosch-gray-60);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-30);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-50);
  --minor-signal-neutral__enabled__front__default: var(--bosch-white);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-30);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-50);
  --minor-signal-error__enabled__front__default: var(--bosch-white);
  --minor-signal-error__enabled__front__hovered: var(--bosch-white);
  --minor-signal-error__enabled__front__pressed: var(--bosch-white);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-30);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-40);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-50);
  --minor-signal-warning__enabled__front__default: var(--bosch-white);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-white);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-white);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-30);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-50);
  --minor-signal-success__enabled__front__default: var(--bosch-white);
  --minor-signal-success__enabled__front__hovered: var(--bosch-white);
  --minor-signal-success__enabled__front__pressed: var(--bosch-white);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-60);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-60);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-95);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-white);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-60);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-70);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-80);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-90);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-30);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-40);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-70);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-80);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-90);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-30);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-40);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-70);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-80);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-90);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-30);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-40);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-70);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-80);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-90);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-50);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-60);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-60);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-70);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-60);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-70);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-60);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-70);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}

.-floating {
  --background: var(--bosch-white);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-90);
  --plain__enabled__fill__pressed: var(--bosch-gray-80);
  --plain__enabled__front__default: var(--bosch-black);
  --plain__enabled__front__hovered: var(--bosch-black);
  --plain__enabled__front__pressed: var(--bosch-black);
  --plain__focused__fill__default: var(--bosch-blue-95);
  --plain__focused__front__default: var(--bosch-black);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-80);
  --neutral__enabled__fill__default: var(--bosch-gray-90);
  --neutral__enabled__fill__hovered: var(--bosch-gray-80);
  --neutral__enabled__fill__pressed: var(--bosch-gray-70);
  --neutral__enabled__front__default: var(--bosch-black);
  --neutral__enabled__front__hovered: var(--bosch-black);
  --neutral__enabled__front__pressed: var(--bosch-black);
  --neutral__focused__fill__default: var(--bosch-blue-90);
  --neutral__focused__front__default: var(--bosch-black);
  --neutral__disabled__fill__default: var(--bosch-gray-90);
  --neutral__disabled__front__default: var(--bosch-gray-70);
  --small__enabled__fill__default: var(--bosch-gray-60);
  --small__enabled__fill__hovered: var(--bosch-gray-50);
  --small__enabled__fill__pressed: var(--bosch-gray-40);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-90);
  --small__disabled__front__default: var(--bosch-gray-70);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-black);
  --integrated__enabled__front__hovered: var(--bosch-blue-50);
  --integrated__enabled__front__pressed: var(--bosch-blue-40);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-80);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-90);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-80);
  --minor-accent__enabled__front__default: var(--bosch-blue-50);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-40);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-30);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-80);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-40);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-30);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-80);
  --major-accent__disabled__front__default: var(--bosch-gray-60);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-90);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-80);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --minor-signal-neutral__enabled__front__default: var(--bosch-black);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-black);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-black);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-90);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-80);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --minor-signal-error__enabled__front__default: var(--bosch-black);
  --minor-signal-error__enabled__front__hovered: var(--bosch-black);
  --minor-signal-error__enabled__front__pressed: var(--bosch-black);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-90);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-80);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-70);
  --minor-signal-warning__enabled__front__default: var(--bosch-black);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-black);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-black);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-90);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-80);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --minor-signal-success__enabled__front__default: var(--bosch-black);
  --minor-signal-success__enabled__front__hovered: var(--bosch-black);
  --minor-signal-success__enabled__front__pressed: var(--bosch-black);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-30);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-30);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-75);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-yellow-65);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-30);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-90);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-80);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-20);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-90);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-80);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-50);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-40);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-30);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-90);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-80);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-50);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-40);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-30);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-90);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-80);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-50);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-40);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-30);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-20);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-40);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-30);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-40);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-30);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-40);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-30);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}

.-dark-mode {
  --shadow-fill: black;
}
.-dark-mode, .-dark-mode .-primary {
  --background: var(--bosch-gray-10);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-20);
  --plain__enabled__fill__pressed: var(--bosch-gray-30);
  --plain__enabled__front__default: var(--bosch-white);
  --plain__enabled__front__hovered: var(--bosch-white);
  --plain__enabled__front__pressed: var(--bosch-white);
  --plain__focused__fill__default: var(--bosch-blue-15);
  --plain__focused__front__default: var(--bosch-white);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-30);
  --neutral__enabled__fill__default: var(--bosch-gray-20);
  --neutral__enabled__fill__hovered: var(--bosch-gray-30);
  --neutral__enabled__fill__pressed: var(--bosch-gray-40);
  --neutral__enabled__front__default: var(--bosch-white);
  --neutral__enabled__front__hovered: var(--bosch-white);
  --neutral__enabled__front__pressed: var(--bosch-white);
  --neutral__focused__fill__default: var(--bosch-blue-20);
  --neutral__focused__front__default: var(--bosch-white);
  --neutral__disabled__fill__default: var(--bosch-gray-20);
  --neutral__disabled__front__default: var(--bosch-gray-40);
  --small__enabled__fill__default: var(--bosch-gray-50);
  --small__enabled__fill__hovered: var(--bosch-gray-60);
  --small__enabled__fill__pressed: var(--bosch-gray-70);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-20);
  --small__disabled__front__default: var(--bosch-gray-40);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-white);
  --integrated__enabled__front__hovered: var(--bosch-blue-60);
  --integrated__enabled__front__pressed: var(--bosch-blue-70);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-30);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-20);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-30);
  --minor-accent__enabled__front__default: var(--bosch-blue-60);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-70);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-80);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-30);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-60);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-70);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-30);
  --major-accent__disabled__front__default: var(--bosch-gray-50);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-20);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-30);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-40);
  --minor-signal-neutral__enabled__front__default: var(--bosch-white);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-20);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-30);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-40);
  --minor-signal-error__enabled__front__default: var(--bosch-white);
  --minor-signal-error__enabled__front__hovered: var(--bosch-white);
  --minor-signal-error__enabled__front__pressed: var(--bosch-white);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-20);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-30);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-40);
  --minor-signal-warning__enabled__front__default: var(--bosch-white);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-white);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-white);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-20);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-30);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-40);
  --minor-signal-success__enabled__front__default: var(--bosch-white);
  --minor-signal-success__enabled__front__hovered: var(--bosch-white);
  --minor-signal-success__enabled__front__pressed: var(--bosch-white);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-60);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-60);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-95);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-white);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-60);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-20);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-60);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-70);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-80);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-20);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-30);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-60);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-70);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-80);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-20);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-30);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-60);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-70);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-80);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-20);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-30);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-60);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-70);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-80);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-50);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-60);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-60);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-70);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-60);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-70);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-60);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-70);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}
.-dark-mode .-secondary {
  --background: var(--bosch-gray-5);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-15);
  --plain__enabled__fill__pressed: var(--bosch-gray-25);
  --plain__enabled__front__default: var(--bosch-white);
  --plain__enabled__front__hovered: var(--bosch-white);
  --plain__enabled__front__pressed: var(--bosch-white);
  --plain__focused__fill__default: var(--bosch-blue-10);
  --plain__focused__front__default: var(--bosch-white);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-25);
  --neutral__enabled__fill__default: var(--bosch-gray-15);
  --neutral__enabled__fill__hovered: var(--bosch-gray-25);
  --neutral__enabled__fill__pressed: var(--bosch-gray-35);
  --neutral__enabled__front__default: var(--bosch-white);
  --neutral__enabled__front__hovered: var(--bosch-white);
  --neutral__enabled__front__pressed: var(--bosch-white);
  --neutral__focused__fill__default: var(--bosch-blue-15);
  --neutral__focused__front__default: var(--bosch-white);
  --neutral__disabled__fill__default: var(--bosch-gray-15);
  --neutral__disabled__front__default: var(--bosch-gray-35);
  --small__enabled__fill__default: var(--bosch-gray-45);
  --small__enabled__fill__hovered: var(--bosch-gray-55);
  --small__enabled__fill__pressed: var(--bosch-gray-65);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-15);
  --small__disabled__front__default: var(--bosch-gray-35);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-white);
  --integrated__enabled__front__hovered: var(--bosch-blue-55);
  --integrated__enabled__front__pressed: var(--bosch-blue-65);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-25);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-15);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-25);
  --minor-accent__enabled__front__default: var(--bosch-blue-55);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-65);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-75);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-25);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-60);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-70);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-25);
  --major-accent__disabled__front__default: var(--bosch-gray-45);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-15);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-25);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-35);
  --minor-signal-neutral__enabled__front__default: var(--bosch-white);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-15);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-25);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-35);
  --minor-signal-error__enabled__front__default: var(--bosch-white);
  --minor-signal-error__enabled__front__hovered: var(--bosch-white);
  --minor-signal-error__enabled__front__pressed: var(--bosch-white);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-15);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-25);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-35);
  --minor-signal-warning__enabled__front__default: var(--bosch-white);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-white);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-white);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-15);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-25);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-35);
  --minor-signal-success__enabled__front__default: var(--bosch-white);
  --minor-signal-success__enabled__front__hovered: var(--bosch-white);
  --minor-signal-success__enabled__front__pressed: var(--bosch-white);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-60);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-60);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-95);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-white);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-60);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-15);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-25);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-55);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-65);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-75);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-15);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-25);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-55);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-65);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-75);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-15);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-25);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-55);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-65);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-75);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-15);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-25);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-55);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-65);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-75);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-50);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-60);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-60);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-70);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-60);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-70);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-60);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-70);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}
.-dark-mode .-contrast {
  --background: var(--bosch-gray-20);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-30);
  --plain__enabled__fill__pressed: var(--bosch-gray-40);
  --plain__enabled__front__default: var(--bosch-white);
  --plain__enabled__front__hovered: var(--bosch-white);
  --plain__enabled__front__pressed: var(--bosch-white);
  --plain__focused__fill__default: var(--bosch-blue-25);
  --plain__focused__front__default: var(--bosch-white);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-40);
  --neutral__enabled__fill__default: var(--bosch-gray-30);
  --neutral__enabled__fill__hovered: var(--bosch-gray-40);
  --neutral__enabled__fill__pressed: var(--bosch-gray-50);
  --neutral__enabled__front__default: var(--bosch-white);
  --neutral__enabled__front__hovered: var(--bosch-white);
  --neutral__enabled__front__pressed: var(--bosch-white);
  --neutral__focused__fill__default: var(--bosch-blue-30);
  --neutral__focused__front__default: var(--bosch-white);
  --neutral__disabled__fill__default: var(--bosch-gray-30);
  --neutral__disabled__front__default: var(--bosch-gray-50);
  --small__enabled__fill__default: var(--bosch-gray-60);
  --small__enabled__fill__hovered: var(--bosch-gray-70);
  --small__enabled__fill__pressed: var(--bosch-gray-80);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-30);
  --small__disabled__front__default: var(--bosch-gray-50);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-white);
  --integrated__enabled__front__hovered: var(--bosch-blue-70);
  --integrated__enabled__front__pressed: var(--bosch-blue-80);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-40);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-30);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-40);
  --minor-accent__enabled__front__default: var(--bosch-blue-70);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-80);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-90);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-40);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-60);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-70);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-40);
  --major-accent__disabled__front__default: var(--bosch-gray-60);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-30);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-50);
  --minor-signal-neutral__enabled__front__default: var(--bosch-white);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-30);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-50);
  --minor-signal-error__enabled__front__default: var(--bosch-white);
  --minor-signal-error__enabled__front__hovered: var(--bosch-white);
  --minor-signal-error__enabled__front__pressed: var(--bosch-white);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-30);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-40);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-50);
  --minor-signal-warning__enabled__front__default: var(--bosch-white);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-white);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-white);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-30);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-50);
  --minor-signal-success__enabled__front__default: var(--bosch-white);
  --minor-signal-success__enabled__front__hovered: var(--bosch-white);
  --minor-signal-success__enabled__front__pressed: var(--bosch-white);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-60);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-60);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-95);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-white);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-60);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-70);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-80);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-90);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-30);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-40);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-70);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-80);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-90);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-30);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-40);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-70);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-80);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-90);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-30);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-40);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-70);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-80);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-90);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-50);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-60);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-60);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-70);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-60);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-70);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-60);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-70);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}
.-dark-mode .-floating {
  --background: var(--bosch-gray-15);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-25);
  --plain__enabled__fill__pressed: var(--bosch-gray-35);
  --plain__enabled__front__default: var(--bosch-white);
  --plain__enabled__front__hovered: var(--bosch-white);
  --plain__enabled__front__pressed: var(--bosch-white);
  --plain__focused__fill__default: var(--bosch-blue-20);
  --plain__focused__front__default: var(--bosch-white);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-35);
  --neutral__enabled__fill__default: var(--bosch-gray-25);
  --neutral__enabled__fill__hovered: var(--bosch-gray-35);
  --neutral__enabled__fill__pressed: var(--bosch-gray-45);
  --neutral__enabled__front__default: var(--bosch-white);
  --neutral__enabled__front__hovered: var(--bosch-white);
  --neutral__enabled__front__pressed: var(--bosch-white);
  --neutral__focused__fill__default: var(--bosch-blue-25);
  --neutral__focused__front__default: var(--bosch-white);
  --neutral__disabled__fill__default: var(--bosch-gray-25);
  --neutral__disabled__front__default: var(--bosch-gray-45);
  --small__enabled__fill__default: var(--bosch-gray-55);
  --small__enabled__fill__hovered: var(--bosch-gray-65);
  --small__enabled__fill__pressed: var(--bosch-gray-75);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-25);
  --small__disabled__front__default: var(--bosch-gray-45);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-white);
  --integrated__enabled__front__hovered: var(--bosch-blue-65);
  --integrated__enabled__front__pressed: var(--bosch-blue-75);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-35);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-25);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-35);
  --minor-accent__enabled__front__default: var(--bosch-blue-65);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-75);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-85);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-35);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-60);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-70);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-35);
  --major-accent__disabled__front__default: var(--bosch-gray-55);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-25);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-35);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-45);
  --minor-signal-neutral__enabled__front__default: var(--bosch-white);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-25);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-35);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-45);
  --minor-signal-error__enabled__front__default: var(--bosch-white);
  --minor-signal-error__enabled__front__hovered: var(--bosch-white);
  --minor-signal-error__enabled__front__pressed: var(--bosch-white);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-25);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-35);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-45);
  --minor-signal-warning__enabled__front__default: var(--bosch-white);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-white);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-white);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-25);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-35);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-45);
  --minor-signal-success__enabled__front__default: var(--bosch-white);
  --minor-signal-success__enabled__front__hovered: var(--bosch-white);
  --minor-signal-success__enabled__front__pressed: var(--bosch-white);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-60);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-60);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-95);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-white);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-60);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-25);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-35);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-65);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-75);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-85);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-25);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-35);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-65);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-75);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-85);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-25);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-35);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-65);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-75);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-85);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-25);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-35);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-65);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-75);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-85);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-50);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-60);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-60);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-70);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-60);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-70);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-60);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-70);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}

.-light-mode {
  --shadow-fill: rgba(0, 0, 0, 0.25);
}
.-light-mode, .-light-mode .-primary {
  --background: var(--bosch-white);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-90);
  --plain__enabled__fill__pressed: var(--bosch-gray-80);
  --plain__enabled__front__default: var(--bosch-black);
  --plain__enabled__front__hovered: var(--bosch-black);
  --plain__enabled__front__pressed: var(--bosch-black);
  --plain__focused__fill__default: var(--bosch-blue-95);
  --plain__focused__front__default: var(--bosch-black);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-80);
  --neutral__enabled__fill__default: var(--bosch-gray-90);
  --neutral__enabled__fill__hovered: var(--bosch-gray-80);
  --neutral__enabled__fill__pressed: var(--bosch-gray-70);
  --neutral__enabled__front__default: var(--bosch-black);
  --neutral__enabled__front__hovered: var(--bosch-black);
  --neutral__enabled__front__pressed: var(--bosch-black);
  --neutral__focused__fill__default: var(--bosch-blue-90);
  --neutral__focused__front__default: var(--bosch-black);
  --neutral__disabled__fill__default: var(--bosch-gray-90);
  --neutral__disabled__front__default: var(--bosch-gray-70);
  --small__enabled__fill__default: var(--bosch-gray-60);
  --small__enabled__fill__hovered: var(--bosch-gray-50);
  --small__enabled__fill__pressed: var(--bosch-gray-40);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-90);
  --small__disabled__front__default: var(--bosch-gray-70);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-black);
  --integrated__enabled__front__hovered: var(--bosch-blue-50);
  --integrated__enabled__front__pressed: var(--bosch-blue-40);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-80);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-90);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-80);
  --minor-accent__enabled__front__default: var(--bosch-blue-50);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-40);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-30);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-80);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-40);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-30);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-80);
  --major-accent__disabled__front__default: var(--bosch-gray-60);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-90);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-80);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --minor-signal-neutral__enabled__front__default: var(--bosch-black);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-black);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-black);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-90);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-80);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --minor-signal-error__enabled__front__default: var(--bosch-black);
  --minor-signal-error__enabled__front__hovered: var(--bosch-black);
  --minor-signal-error__enabled__front__pressed: var(--bosch-black);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-90);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-80);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-70);
  --minor-signal-warning__enabled__front__default: var(--bosch-black);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-black);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-black);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-90);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-80);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --minor-signal-success__enabled__front__default: var(--bosch-black);
  --minor-signal-success__enabled__front__hovered: var(--bosch-black);
  --minor-signal-success__enabled__front__pressed: var(--bosch-black);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-30);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-30);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-75);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-yellow-65);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-30);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-90);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-80);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-20);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-90);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-80);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-50);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-40);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-30);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-90);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-80);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-50);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-40);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-30);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-90);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-80);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-50);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-40);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-30);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-20);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-40);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-30);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-40);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-30);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-40);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-30);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}
.-light-mode .-secondary {
  --background: var(--bosch-gray-95);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-85);
  --plain__enabled__fill__pressed: var(--bosch-gray-75);
  --plain__enabled__front__default: var(--bosch-black);
  --plain__enabled__front__hovered: var(--bosch-black);
  --plain__enabled__front__pressed: var(--bosch-black);
  --plain__focused__fill__default: var(--bosch-blue-90);
  --plain__focused__front__default: var(--bosch-black);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-75);
  --neutral__enabled__fill__default: var(--bosch-gray-85);
  --neutral__enabled__fill__hovered: var(--bosch-gray-75);
  --neutral__enabled__fill__pressed: var(--bosch-gray-65);
  --neutral__enabled__front__default: var(--bosch-black);
  --neutral__enabled__front__hovered: var(--bosch-black);
  --neutral__enabled__front__pressed: var(--bosch-black);
  --neutral__focused__fill__default: var(--bosch-blue-85);
  --neutral__focused__front__default: var(--bosch-black);
  --neutral__disabled__fill__default: var(--bosch-gray-85);
  --neutral__disabled__front__default: var(--bosch-gray-65);
  --small__enabled__fill__default: var(--bosch-gray-55);
  --small__enabled__fill__hovered: var(--bosch-gray-45);
  --small__enabled__fill__pressed: var(--bosch-gray-35);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-85);
  --small__disabled__front__default: var(--bosch-gray-65);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-black);
  --integrated__enabled__front__hovered: var(--bosch-blue-45);
  --integrated__enabled__front__pressed: var(--bosch-blue-35);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-75);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-85);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-75);
  --minor-accent__enabled__front__default: var(--bosch-blue-45);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-35);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-25);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-75);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-40);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-30);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-75);
  --major-accent__disabled__front__default: var(--bosch-gray-55);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-85);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-75);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-65);
  --minor-signal-neutral__enabled__front__default: var(--bosch-black);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-black);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-black);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-85);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-75);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-65);
  --minor-signal-error__enabled__front__default: var(--bosch-black);
  --minor-signal-error__enabled__front__hovered: var(--bosch-black);
  --minor-signal-error__enabled__front__pressed: var(--bosch-black);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-75);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-65);
  --minor-signal-warning__enabled__front__default: var(--bosch-black);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-black);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-black);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-85);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-75);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-65);
  --minor-signal-success__enabled__front__default: var(--bosch-black);
  --minor-signal-success__enabled__front__hovered: var(--bosch-black);
  --minor-signal-success__enabled__front__pressed: var(--bosch-black);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-30);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-30);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-75);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-yellow-65);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-30);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-85);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-75);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-20);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-85);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-75);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-45);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-35);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-25);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-85);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-75);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-45);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-35);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-25);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-85);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-75);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-45);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-35);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-25);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-20);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-40);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-30);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-40);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-30);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-40);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-30);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}
.-light-mode .-contrast {
  --background: var(--bosch-gray-20);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-30);
  --plain__enabled__fill__pressed: var(--bosch-gray-40);
  --plain__enabled__front__default: var(--bosch-white);
  --plain__enabled__front__hovered: var(--bosch-white);
  --plain__enabled__front__pressed: var(--bosch-white);
  --plain__focused__fill__default: var(--bosch-blue-25);
  --plain__focused__front__default: var(--bosch-white);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-40);
  --neutral__enabled__fill__default: var(--bosch-gray-30);
  --neutral__enabled__fill__hovered: var(--bosch-gray-40);
  --neutral__enabled__fill__pressed: var(--bosch-gray-50);
  --neutral__enabled__front__default: var(--bosch-white);
  --neutral__enabled__front__hovered: var(--bosch-white);
  --neutral__enabled__front__pressed: var(--bosch-white);
  --neutral__focused__fill__default: var(--bosch-blue-30);
  --neutral__focused__front__default: var(--bosch-white);
  --neutral__disabled__fill__default: var(--bosch-gray-30);
  --neutral__disabled__front__default: var(--bosch-gray-50);
  --small__enabled__fill__default: var(--bosch-gray-60);
  --small__enabled__fill__hovered: var(--bosch-gray-70);
  --small__enabled__fill__pressed: var(--bosch-gray-80);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-30);
  --small__disabled__front__default: var(--bosch-gray-50);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-white);
  --integrated__enabled__front__hovered: var(--bosch-blue-70);
  --integrated__enabled__front__pressed: var(--bosch-blue-80);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-40);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-30);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-40);
  --minor-accent__enabled__front__default: var(--bosch-blue-70);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-80);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-90);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-40);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-60);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-70);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-40);
  --major-accent__disabled__front__default: var(--bosch-gray-60);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-30);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-50);
  --minor-signal-neutral__enabled__front__default: var(--bosch-white);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-30);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-50);
  --minor-signal-error__enabled__front__default: var(--bosch-white);
  --minor-signal-error__enabled__front__hovered: var(--bosch-white);
  --minor-signal-error__enabled__front__pressed: var(--bosch-white);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-30);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-40);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-50);
  --minor-signal-warning__enabled__front__default: var(--bosch-white);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-white);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-white);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-30);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-50);
  --minor-signal-success__enabled__front__default: var(--bosch-white);
  --minor-signal-success__enabled__front__hovered: var(--bosch-white);
  --minor-signal-success__enabled__front__pressed: var(--bosch-white);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-60);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-60);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-95);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-white);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-60);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-70);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-80);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-90);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-30);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-40);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-70);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-80);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-90);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-30);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-40);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-70);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-80);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-90);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-30);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-40);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-70);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-80);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-90);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-50);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-60);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-60);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-70);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-60);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-70);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-60);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-70);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}
.-light-mode .-floating {
  --background: var(--bosch-white);
  --plain__enabled__fill__default: transparent;
  --plain__enabled__fill__hovered: var(--bosch-gray-90);
  --plain__enabled__fill__pressed: var(--bosch-gray-80);
  --plain__enabled__front__default: var(--bosch-black);
  --plain__enabled__front__hovered: var(--bosch-black);
  --plain__enabled__front__pressed: var(--bosch-black);
  --plain__focused__fill__default: var(--bosch-blue-95);
  --plain__focused__front__default: var(--bosch-black);
  --plain__disabled__fill__default: transparent;
  --plain__disabled__front__default: var(--bosch-gray-80);
  --neutral__enabled__fill__default: var(--bosch-gray-90);
  --neutral__enabled__fill__hovered: var(--bosch-gray-80);
  --neutral__enabled__fill__pressed: var(--bosch-gray-70);
  --neutral__enabled__front__default: var(--bosch-black);
  --neutral__enabled__front__hovered: var(--bosch-black);
  --neutral__enabled__front__pressed: var(--bosch-black);
  --neutral__focused__fill__default: var(--bosch-blue-90);
  --neutral__focused__front__default: var(--bosch-black);
  --neutral__disabled__fill__default: var(--bosch-gray-90);
  --neutral__disabled__front__default: var(--bosch-gray-70);
  --small__enabled__fill__default: var(--bosch-gray-60);
  --small__enabled__fill__hovered: var(--bosch-gray-50);
  --small__enabled__fill__pressed: var(--bosch-gray-40);
  --small__enabled__front__default: var(--bosch-white);
  --small__enabled__front__hovered: var(--bosch-white);
  --small__enabled__front__pressed: var(--bosch-white);
  --small__disabled__fill__default: var(--bosch-gray-90);
  --small__disabled__front__default: var(--bosch-gray-70);
  --integrated__enabled__fill__default: transparent;
  --integrated__enabled__fill__hovered: transparent;
  --integrated__enabled__fill__pressed: transparent;
  --integrated__enabled__front__default: var(--bosch-black);
  --integrated__enabled__front__hovered: var(--bosch-blue-50);
  --integrated__enabled__front__pressed: var(--bosch-blue-40);
  --integrated__disabled__fill__default: transparent;
  --integrated__disabled__front__default: var(--bosch-gray-80);
  --minor-accent__enabled__fill__default: transparent;
  --minor-accent__enabled__fill__hovered: var(--bosch-blue-90);
  --minor-accent__enabled__fill__pressed: var(--bosch-blue-80);
  --minor-accent__enabled__front__default: var(--bosch-blue-50);
  --minor-accent__enabled__front__hovered: var(--bosch-blue-40);
  --minor-accent__enabled__front__pressed: var(--bosch-blue-30);
  --minor-accent__disabled__fill__default: transparent;
  --minor-accent__disabled__front__default: var(--bosch-gray-80);
  --major-accent__enabled__fill__default: var(--bosch-blue-50);
  --major-accent__enabled__fill__hovered: var(--bosch-blue-40);
  --major-accent__enabled__fill__pressed: var(--bosch-blue-30);
  --major-accent__enabled__front__default: var(--bosch-white);
  --major-accent__enabled__front__hovered: var(--bosch-white);
  --major-accent__enabled__front__pressed: var(--bosch-white);
  --major-accent__disabled__fill__default: var(--bosch-gray-80);
  --major-accent__disabled__front__default: var(--bosch-gray-60);
  --minor-signal-neutral__enabled__fill__default: var(--bosch-blue-90);
  --minor-signal-neutral__enabled__fill__hovered: var(--bosch-blue-80);
  --minor-signal-neutral__enabled__fill__pressed: var(--bosch-blue-70);
  --minor-signal-neutral__enabled__front__default: var(--bosch-black);
  --minor-signal-neutral__enabled__front__hovered: var(--bosch-black);
  --minor-signal-neutral__enabled__front__pressed: var(--bosch-black);
  --minor-signal-error__enabled__fill__default: var(--bosch-red-90);
  --minor-signal-error__enabled__fill__hovered: var(--bosch-red-80);
  --minor-signal-error__enabled__fill__pressed: var(--bosch-red-70);
  --minor-signal-error__enabled__front__default: var(--bosch-black);
  --minor-signal-error__enabled__front__hovered: var(--bosch-black);
  --minor-signal-error__enabled__front__pressed: var(--bosch-black);
  --minor-signal-warning__enabled__fill__default: var(--bosch-yellow-90);
  --minor-signal-warning__enabled__fill__hovered: var(--bosch-yellow-80);
  --minor-signal-warning__enabled__fill__pressed: var(--bosch-yellow-70);
  --minor-signal-warning__enabled__front__default: var(--bosch-black);
  --minor-signal-warning__enabled__front__hovered: var(--bosch-black);
  --minor-signal-warning__enabled__front__pressed: var(--bosch-black);
  --minor-signal-success__enabled__fill__default: var(--bosch-green-90);
  --minor-signal-success__enabled__fill__hovered: var(--bosch-green-80);
  --minor-signal-success__enabled__fill__pressed: var(--bosch-green-70);
  --minor-signal-success__enabled__front__default: var(--bosch-black);
  --minor-signal-success__enabled__front__hovered: var(--bosch-black);
  --minor-signal-success__enabled__front__pressed: var(--bosch-black);
  --major-signal-neutral__enabled__fill__default: var(--bosch-blue-50);
  --major-signal-neutral__enabled__fill__hovered: var(--bosch-blue-40);
  --major-signal-neutral__enabled__fill__pressed: var(--bosch-blue-30);
  --major-signal-neutral__enabled__front__default: var(--bosch-white);
  --major-signal-neutral__enabled__front__hovered: var(--bosch-white);
  --major-signal-neutral__enabled__front__pressed: var(--bosch-white);
  --major-signal-error__enabled__fill__default: var(--bosch-red-50);
  --major-signal-error__enabled__fill__hovered: var(--bosch-red-40);
  --major-signal-error__enabled__fill__pressed: var(--bosch-red-30);
  --major-signal-error__enabled__front__default: var(--bosch-white);
  --major-signal-error__enabled__front__hovered: var(--bosch-white);
  --major-signal-error__enabled__front__pressed: var(--bosch-white);
  --major-signal-warning__enabled__fill__default: var(--bosch-yellow-85);
  --major-signal-warning__enabled__fill__hovered: var(--bosch-yellow-75);
  --major-signal-warning__enabled__fill__pressed: var(--bosch-yellow-65);
  --major-signal-warning__enabled__front__default: var(--bosch-black);
  --major-signal-warning__enabled__front__hovered: var(--bosch-black);
  --major-signal-warning__enabled__front__pressed: var(--bosch-black);
  --major-signal-success__enabled__fill__default: var(--bosch-green-50);
  --major-signal-success__enabled__fill__hovered: var(--bosch-green-40);
  --major-signal-success__enabled__fill__pressed: var(--bosch-green-30);
  --major-signal-success__enabled__front__default: var(--bosch-white);
  --major-signal-success__enabled__front__hovered: var(--bosch-white);
  --major-signal-success__enabled__front__pressed: var(--bosch-white);
  --minor-highlight-purple__enabled__fill__default: transparent;
  --minor-highlight-purple__enabled__fill__hovered: var(--bosch-purple-90);
  --minor-highlight-purple__enabled__fill__pressed: var(--bosch-purple-80);
  --minor-highlight-purple__enabled__front__default: var(--bosch-purple-40);
  --minor-highlight-purple__enabled__front__hovered: var(--bosch-purple-30);
  --minor-highlight-purple__enabled__front__pressed: var(--bosch-purple-20);
  --minor-highlight-blue__enabled__fill__default: transparent;
  --minor-highlight-blue__enabled__fill__hovered: var(--bosch-blue-90);
  --minor-highlight-blue__enabled__fill__pressed: var(--bosch-blue-80);
  --minor-highlight-blue__enabled__front__default: var(--bosch-blue-50);
  --minor-highlight-blue__enabled__front__hovered: var(--bosch-blue-40);
  --minor-highlight-blue__enabled__front__pressed: var(--bosch-blue-30);
  --minor-highlight-turquoise__enabled__fill__default: transparent;
  --minor-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-90);
  --minor-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-80);
  --minor-highlight-turquoise__enabled__front__default: var(--bosch-turquoise-50);
  --minor-highlight-turquoise__enabled__front__hovered: var(--bosch-turquoise-40);
  --minor-highlight-turquoise__enabled__front__pressed: var(--bosch-turquoise-30);
  --minor-highlight-green__enabled__fill__default: transparent;
  --minor-highlight-green__enabled__fill__hovered: var(--bosch-green-90);
  --minor-highlight-green__enabled__fill__pressed: var(--bosch-green-80);
  --minor-highlight-green__enabled__front__default: var(--bosch-green-50);
  --minor-highlight-green__enabled__front__hovered: var(--bosch-green-40);
  --minor-highlight-green__enabled__front__pressed: var(--bosch-green-30);
  --major-highlight-purple__enabled__fill__default: var(--bosch-purple-40);
  --major-highlight-purple__enabled__fill__hovered: var(--bosch-purple-30);
  --major-highlight-purple__enabled__fill__pressed: var(--bosch-purple-20);
  --major-highlight-purple__enabled__front__default: var(--bosch-white);
  --major-highlight-purple__enabled__front__hovered: var(--bosch-white);
  --major-highlight-purple__enabled__front__pressed: var(--bosch-white);
  --major-highlight-blue__enabled__fill__default: var(--bosch-blue-50);
  --major-highlight-blue__enabled__fill__hovered: var(--bosch-blue-40);
  --major-highlight-blue__enabled__fill__pressed: var(--bosch-blue-30);
  --major-highlight-blue__enabled__front__default: var(--bosch-white);
  --major-highlight-blue__enabled__front__hovered: var(--bosch-white);
  --major-highlight-blue__enabled__front__pressed: var(--bosch-white);
  --major-highlight-turquoise__enabled__fill__default: var(--bosch-turquoise-50);
  --major-highlight-turquoise__enabled__fill__hovered: var(--bosch-turquoise-40);
  --major-highlight-turquoise__enabled__fill__pressed: var(--bosch-turquoise-30);
  --major-highlight-turquoise__enabled__front__default: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__hovered: var(--bosch-white);
  --major-highlight-turquoise__enabled__front__pressed: var(--bosch-white);
  --major-highlight-green__enabled__fill__default: var(--bosch-green-50);
  --major-highlight-green__enabled__fill__hovered: var(--bosch-green-40);
  --major-highlight-green__enabled__fill__pressed: var(--bosch-green-30);
  --major-highlight-green__enabled__front__default: var(--bosch-white);
  --major-highlight-green__enabled__front__hovered: var(--bosch-white);
  --major-highlight-green__enabled__front__pressed: var(--bosch-white);
  background-color: var(--background);
  color: var(--plain__enabled__front__default);
}

html,
body {
  font-family: boschsans, "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

input,
textarea,
select,
button {
  font-family: inherit;
  border-radius: 0;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.highlight {
  font-weight: 700;
}

.text {
  font-weight: 400;
}

.quote {
  font-weight: 400;
  font-style: italic;
}

.list-element {
  font-weight: 400;
  margin-bottom: 1rem;
}

.label {
  font-weight: 400;
}

.-size-6xl {
  font-size: 5rem;
  line-height: 1.15;
}

.-size-5xl {
  font-size: 4rem;
  line-height: 1.2;
}

.-size-4xl {
  font-size: 3rem;
  line-height: 1.25;
}

.-size-3xl {
  font-size: 2.5rem;
  line-height: 1.3;
}

.-size-2xl {
  font-size: 2rem;
  line-height: 1.35;
}

.-size-xl {
  font-size: 1.5rem;
  line-height: 1.4;
}

.-size-l {
  font-size: 1.25rem;
  line-height: 1.5;
}

.-size-m {
  font-size: 1rem;
  line-height: 1.5;
}

.-size-s {
  font-size: 0.75rem;
  line-height: 1.5;
}

h1 {
  font-weight: 700;
  font-size: 3rem;
  line-height: 1.25;
}

h2 {
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 1.3;
}

h3 {
  font-weight: 700;
  font-size: 2rem;
  line-height: 1.35;
}

h4 {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.4;
}

h5 {
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.5;
}

p {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
}

li {
  font-weight: 400;
  margin-bottom: 1rem;
  font-size: 1rem;
  line-height: 1.5;
}

button {
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
}

figcaption {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.5;
}

label {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.5;
}

/* container for on-grid design without full width background color */
.e-container {
  width: calc(100% - 2rem);
  max-width: 1120px;
  margin: 0 1rem;
  /* all direct descendent get styles for max-width */
}
.e-container > * {
  max-width: 1120px;
  margin: 0 auto;
}

/* 1120 + 2 * 2rem from margin/padding */
@media (min-width: 1152px) {
  .e-container {
    width: 100%;
    margin: 0 auto;
  }
}
/* container which is full width to color background on full width */
.e-container.-full-width {
  width: 100%;
  max-width: unset;
  margin: 0;
  padding: 0 1rem;
}
.e-container.-full-width > * {
  margin: 0 auto;
}

/* stylelint-disable no-descending-specificity */
a,
a:visited {
  color: var(--minor-accent__enabled__front__default);
}
a:hover,
a:visited:hover {
  color: var(--minor-accent__enabled__front__hovered);
}
a:active,
a:visited:active {
  color: var(--minor-accent__enabled__front__pressed);
}
a:disabled,
a:visited:disabled {
  pointer-events: none;
  color: var(--minor-accent__disabled__front__default);
}

.a-link {
  text-decoration: none;
  color: var(--minor-accent__enabled__front__default);
}
.a-link a {
  color: currentColor;
}
.a-link:hover {
  color: var(--minor-accent__enabled__front__hovered);
}
.a-link:hover a {
  text-decoration: underline;
}
.a-link:active {
  color: var(--minor-accent__enabled__front__pressed);
}
.a-link.-disabled, .a-link.-disabled a {
  pointer-events: none;
  color: var(--minor-accent__disabled__front__default);
}

.a-link--simple,
.a-link--primary {
  display: inline-block;
}
.a-link--simple a,
.a-link--primary a {
  display: flex;
}
.a-link--simple a,
.a-link--simple a:visited,
.a-link--primary a,
.a-link--primary a:visited {
  text-decoration: none;
}
.a-link--simple a:hover,
.a-link--simple a:visited:hover,
.a-link--primary a:hover,
.a-link--primary a:visited:hover {
  text-decoration: underline;
}

.a-link--primary a::after {
  content: "";
  border-top: 0.0625rem solid currentColor;
  border-right: 0.0625rem solid currentColor;
  position: relative;
  width: 0.5em;
  height: 0.5em;
  margin-left: 0.25em;
  transform: translateY(0.465em) rotate(45deg);
}

.a-link:hover .a-icon,
.a-link:hover .a-icon::before {
  display: inline-block;
  text-decoration: none;
}

.a-link.-icon-left .a-icon {
  margin-right: 0.5rem;
}

.a-link.-icon-right a {
  display: inline;
}

.a-link.-icon-right .a-icon {
  margin-left: 0.5rem;
  display: inline-block;
  margin-top: -1rem;
  position: relative;
  top: 0.25rem;
}